import Link from "next/link";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";

export function BlikErrorMessage() {
  const mode = useOfferMode();

  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          płatność nie powiodła się
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="mobile-alt-incircle-fail"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Sprawdź środki na swoim koncie i spróbuj jeszcze raz.
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="only-mobile:flex-col flex justify-center">
        <Link href={portalRoutes.mojeKonto.index.get({ mode })} passHref={true}>
          <A
            size={{
              "@onlyMobile": "s",
            }}
          >
            ok
          </A>
        </Link>
      </div>
    </Panel>
  );
}
